(function () {
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  ready(function () {
    document.querySelectorAll("[data-cdt-root]").forEach((root) => {
      const tabButtons = root.querySelectorAll("[data-cdt-tab]");
      const panels = root.querySelectorAll("[data-cdt-panel]");
      const swiperMap = new Map();
      
      function datacontactdirectorytabscontentanimation(panel, options = { onlyVisible: false }) {
        if (!panel) return;

        let metaItems = panel.querySelectorAll(".cdt-card__meta-item");

        if (options.onlyVisible) {
          // Filter only visible items
          metaItems = [...metaItems].filter(item => item.offsetParent !== null); // offsetParent null means hidden
        } else {
          // Animate first time per tab panel only
          if (panel.getAttribute("data-gsap-done") === "true") return;
          panel.setAttribute("data-gsap-done", "true");
        }

        if (metaItems.length === 0) return;

        gsap.fromTo(
          metaItems,
          { opacity: 0, y: 20 },
          { opacity: 1, y: 0, duration: 0.6, stagger: 0.2, ease: "power2.out" }
        );
      }

      function applyFilter(panel, filterValue) {
          if (!panel) return;
           datacontactdirectorytabscontentanimation(panel, { onlyVisible: true });
          const swiperEl = panel.querySelector("[data-cdt-swiper]");
          const wrapper  = panel.querySelector("[data-cdt-wrapper]");
          if (!swiperEl || !wrapper) return;

          const slides = [...wrapper.children];

          slides.forEach((slide) => {
              const key = (slide.getAttribute("data-filter") || "jocky").trim();
              const show =  (key === filterValue);
              slide.style.display = show ? "" : "none";
          });

          // If swiper exists, force it to recalc + jump to first visible
          const swiper = swiperMap.get(swiperEl);
          if (swiper) {
            swiper.update();                 // recalculates sizes/slides [web:3]
            swiper.slideTo(0, 0);            // first slide (top/first card) [web:3]
            if (swiper.pagination) {
              swiper.pagination.render?.();  // helps when slide count changes [web:5]
              swiper.pagination.update?.();  // keep bullets correct [web:5]
            }
          }
        }

      function initSwiper(panel) {
        if (!panel || window.innerWidth > 768) return;

        const swiperEl = panel.querySelector("[data-cdt-swiper]");
        if (!swiperEl || swiperMap.has(swiperEl)) return;

        const wrapper = swiperEl.querySelector("[data-cdt-wrapper]");
        const slides = wrapper.children;
        const pagination = panel.querySelector("[data-cdt-pagination]");

        swiperEl.classList.add("swiper");
        wrapper.classList.add("swiper-wrapper");

        [...slides].forEach(slide => {
          slide.classList.add("swiper-slide");
        });

        const swiper = new Swiper(swiperEl, {
          slidesPerView: 1.187,
          spaceBetween: 13,
          centeredSlides: true,
          pagination: {
            el: pagination,
            clickable: true
          }
        });

        swiperMap.set(swiperEl, swiper);
          // Apply default/current filter and start from first slide
        const filterEl = panel.querySelector("[data-cdt-filter]");
        if(!filterEl) return;
        applyFilter(panel, filterEl ? filterEl.value : "jocky");
      }
      function destroyAllSwipers() {
        swiperMap.forEach((swiper, swiperEl) => {
          swiper.destroy(true, true);

          const wrapper = swiperEl.querySelector("[data-cdt-wrapper]");

          swiperEl.classList.remove("swiper");
          wrapper.classList.remove("swiper-wrapper");

          [...wrapper.children].forEach(slide => {
            slide.classList.remove("swiper-slide");
          });
        });

        swiperMap.clear();
      }


    
      function setActive(tabId) {
        let activePanel = null;

        tabButtons.forEach((btn) => {
          const isActive = btn.getAttribute("data-cdt-tab") === tabId;
          btn.classList.toggle("is-active", isActive);
          btn.setAttribute("aria-selected", isActive ? "true" : "false");
          if (isActive) {
            requestAnimationFrame(() => {
              btn.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest"
              });
            });
          }
        });

        panels.forEach((panel) => {
          const isActive = panel.getAttribute("data-cdt-panel") === tabId;
          panel.classList.toggle("is-active", isActive);

          if (isActive) {
            activePanel = panel;
            datacontactdirectorytabscontentanimation(activePanel);
           
          }
           const filterEl = panel.querySelector("[data-cdt-filter]");
            if (!filterEl) return;

            filterEl.addEventListener("change", (e) => {
              applyFilter(panel, e.target.value);
            });
        });

        if (window.innerWidth <= 768) {
          initSwiper(activePanel);
        }
      }

      tabButtons.forEach((btn) => {
        btn.addEventListener("click", () => setActive(btn.getAttribute("data-cdt-tab")));
      });

      // Default first tab active
      if (tabButtons.length) setActive(tabButtons[0].getAttribute("data-cdt-tab"));

      // When resizing to mobile, init active panel swiper
      let resizeTimer;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          const activePanel = root.querySelector(".cdt__panel.is-active");
          if (!activePanel) return;

          const filterEl = activePanel.querySelector("[data-cdt-filter]");
         

          if (window.innerWidth >= 769) {
            destroyAllSwipers();
            if(!filterEl) return;
            applyFilter(activePanel, filterEl ? filterEl.value : "jocky"); // keep same filter on desktop too
          } else {
            initSwiper(activePanel);    
            if(!filterEl) return;           // init if needed
            applyFilter(activePanel, filterEl ? filterEl.value : "jocky"); // ensure filter is applied
          }
        }, 50);
      });
    });
  });
})();
